export enum GameType {
    Slots, Live, Fishing, Sports, Lottery, P2p
}